    const validate_email = () => {
      const email = document.querySelector('[name=email]').value;
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    const update_email = () => {
      const id = document.querySelector('[name=email-id]').value;
      const domain = document.querySelector('[name=email-domain]').value;
      if ( id && domain ) {
        const email = id + '@' + domain;
        document.querySelector('[name=email]').value = email;
        document.getElementsByClassName('email')[0].classList.remove('active');
        // return validate_email();
        console.log('update_email pass');
        return true
      }
      document.getElementsByClassName('email')[0].classList.add('active');
      alert("이메일을 입력하여주세요.");
      return false
    }
    const change_email_domain = function(e) {
      // console.log('change_email_domain called...');
      const domain_type = document.querySelector('[name=email-select]').value;
      const domain_element = document.querySelector('[name=email-domain]');
      if ( domain_type == 'direct' ) {
        domain_element.value = '';
        domain_element.removeAttribute('disabled');
      }
      else {
        domain_element.value = domain_type;
        domain_element.setAttribute('disabled', true);
      }
    }
    const emailHandler = () => {
      // console.log('emailHandler loaded...');
      document.querySelector('[name=email-select]').onchange = change_email_domain;
    }
    window.addEventListener('load', emailHandler, false);



    const csrftoken = jQuery("[name=csrfmiddlewaretoken]").val();
   	const csrfSafeMethod = (method) => {
        // these HTTP methods do not require CSRF protection
        return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
    }
		$.ajaxSetup({
			beforeSend: function(xhr, settings) {
				if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
					xhr.setRequestHeader("X-CSRFToken", csrftoken);
				}
			},
		});
    const validate = () => {
      // console.log('submitHandler');
      console.log('run validate')
      if ( !update_email() ) {
        console.log('update_email failed...');
        return false
      }

      if ( !document.querySelector('input[name="is_consent"]').checked ) {
        $('#id_consent_modal').click()
        return false;
      }

      return true
    }
    const display_error = (name) => {
      // console.log(document.getElementsByClassName(name))
      document.getElementsByClassName(name)[0].classList.add('active');
    }
    const submit_form = () => {
      console.log('submit_form click...')
      if ( validate() ) {
        const data = $('#demo_form').serialize();
        const url = document.getElementById('main_container').getAttribute('data-demo_url')
        $.ajax({
          type: "POST",
          url: url,
          data: data,
          success: function(data) {
            console.log('data', data);
            if ( data['is_success'] == true ) {
              $('#id_success_modal').click()
            }
            else {
              data['error_classes'].forEach(function(name) {
                display_error(name);
              });
              $('#error_message').html(data['error_message'])
              $('.v-message').show()
              $('#id_error_modal').click()
            }
          }
        })
      }
		}
    document.getElementById('submit_form').addEventListener('click', submit_form)
